var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "post-breadcrumbs-section" }, [
    _vm.breadcrumbs && Object.keys(_vm.breadcrumbs).length
      ? _c("ul", { staticClass: "breadcrumbs-ul" }, [
          _vm.breadcrumbs.parent_project_id &&
          _vm.breadcrumbs.parent_project_title
            ? _c(
                "li",
                {
                  staticClass: "goto-parent-link",
                  on: {
                    click: function($event) {
                      return _vm.goToParentProject(
                        _vm.breadcrumbs.parent_project_number
                      )
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.breadcrumbs.parent_project_title) +
                      "\n            "
                  ),
                  _vm.breadcrumbs.parent_project_status.slug &&
                  _vm.breadcrumbs.parent_project_status.slug == "on-hold"
                    ? _c("span", [
                        _vm._v(
                          "\n                (" +
                            _vm._s(_vm.breadcrumbs.parent_project_status.name) +
                            ")\n            "
                        )
                      ])
                    : _vm._e()
                ]
              )
            : _vm.breadcrumbs.parent_project_id &&
              !_vm.breadcrumbs.parent_project_title
            ? _c(
                "li",
                {
                  staticClass: "goto-parent-link",
                  on: {
                    click: function($event) {
                      return _vm.goToParentProject(
                        _vm.breadcrumbs.parent_project_number
                      )
                    }
                  }
                },
                [_vm._v("\n            UNTITLED PROJECT\n        ")]
              )
            : _c("li", [_vm._v("\n            NO PROJECT\n        ")]),
          _vm._v(" "),
          _c("li", { staticClass: "breadcrumbs-icon" }),
          _vm._v(" "),
          _vm.breadcrumbs.parent_deliverable_id &&
          _vm.breadcrumbs.parent_deliverable_title
            ? _c(
                "li",
                {
                  staticClass: "goto-parent-link",
                  on: {
                    click: function($event) {
                      return _vm.goToParentPlan(
                        _vm.breadcrumbs.parent_deliverable_id
                      )
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.breadcrumbs.parent_deliverable_title) +
                      "\n        "
                  )
                ]
              )
            : _vm.breadcrumbs.parent_deliverable_id &&
              !_vm.breadcrumbs.parent_deliverable_title
            ? _c(
                "li",
                {
                  staticClass: "goto-parent-link",
                  on: {
                    click: function($event) {
                      return _vm.goToParentPlan(
                        _vm.breadcrumbs.parent_deliverable_id
                      )
                    }
                  }
                },
                [_vm._v("\n            UNTITLED PLAN\n        ")]
              )
            : _c("li", [_vm._v("\n            NO PLAN\n        ")])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }